module.exports = __webpack_public_path__ + "img/SC7-Insurance_needs.9372ee63.png";